import { isCategoriaDisponible } from '@/helpers/horarioDisponible'

const getters = {
  categorias: state => state.categorias,
  /**
   * Retorna si una categoría está disponible según horarios (de categoría o general).
   * Los horarios de categoría predominan sobre los horarios generales de la tienda.
   * @param {Object} state
   * @param {Object} getters
   * @param {Object} rootState
   * @returns {function(categoria): boolean}
   */
  categoriaDisponible: (state, getters, rootState) => (categoria) => {
    const horarioGeneral = rootState.App && rootState.App.data && rootState.App.data.horarioRegular
    return isCategoriaDisponible(categoria, horarioGeneral)
  }
}

export default getters
